import type { EmpresaCliente } from './empresasClientes';

export type OperadorRole = 'admin_empresa' | 'gerente' | 'operador' | 'visualizador' | (string & {});

export interface OperadorAdmin {
  id: string;
  empresaId: string;
  nome: string;
  email: string;
  cpf?: string;
  senha: string;
  role: OperadorRole;
  ativo: boolean;
  avatar?: string;
}

export const operadoresAdmin: OperadorAdmin[] = [
  // EMP-001: getPoints
  {
    id: 'op-001-01',
    empresaId: 'EMP-001',
    nome: 'João Silva',
    email: 'joao.silva@getpoints.com.br',
    cpf: '123.456.789-09',
    senha: '123456',
    role: 'gerente',
    ativo: true,
  },
  {
    id: 'op-001-02',
    empresaId: 'EMP-001',
    nome: 'Maria Oliveira',
    email: 'maria.oliveira@getpoints.com.br',
    cpf: '987.654.321-00',
    senha: '123456',
    role: 'operador',
    ativo: true,
  },
  {
    id: 'op-001-03',
    empresaId: 'EMP-001',
    nome: 'Pedro Santos',
    email: 'pedro.santos@getpoints.com.br',
    cpf: '456.789.123-45',
    senha: '123456',
    role: 'visualizador',
    ativo: true,
  },
  {
    id: 'op-001-04',
    empresaId: 'EMP-001',
    nome: 'Carla Mendes',
    email: 'carla.mendes@getpoints.com.br',
    cpf: '789.123.456-78',
    senha: '123456',
    role: 'operador',
    ativo: false,
  },

  // EMP-002: Inovação Digital S.A.
  {
    id: 'op-002-01',
    empresaId: 'EMP-002',
    nome: 'Ricardo Almeida',
    email: 'ricardo.almeida@inovacaodigital.com.br',
    cpf: '321.654.987-01',
    senha: 'inovacao2024',
    role: 'gerente',
    ativo: true,
  },
  {
    id: 'op-002-02',
    empresaId: 'EMP-002',
    nome: 'Fernanda Costa',
    email: 'fernanda.costa@inovacaodigital.com.br',
    cpf: '654.987.321-02',
    senha: 'inovacao2024',
    role: 'operador',
    ativo: true,
  },
  {
    id: 'op-002-03',
    empresaId: 'EMP-002',
    nome: 'Lucas Pereira',
    email: 'lucas.pereira@inovacaodigital.com.br',
    cpf: '147.258.369-03',
    senha: 'inovacao2024',
    role: 'visualizador',
    ativo: true,
  },

  // EMP-003: Consultoria Tech Brasil
  {
    id: 'op-003-01',
    empresaId: 'EMP-003',
    nome: 'Amanda Rocha',
    email: 'amanda.rocha@techbrasil.com.br',
    cpf: '369.258.147-04',
    senha: 'tech2024',
    role: 'gerente',
    ativo: true,
  },
  {
    id: 'op-003-02',
    empresaId: 'EMP-003',
    nome: 'Bruno Carvalho',
    email: 'bruno.carvalho@techbrasil.com.br',
    cpf: '258.147.369-05',
    senha: 'tech2024',
    role: 'operador',
    ativo: true,
  },

  // EMP-004: Sistemas Integrados Ltda
  {
    id: 'op-004-01',
    empresaId: 'EMP-004',
    nome: 'Daniela Freitas',
    email: 'daniela.freitas@sistemasintegrados.com.br',
    cpf: '741.852.963-06',
    senha: 'sistemas2024',
    role: 'gerente',
    ativo: true,
  },
  {
    id: 'op-004-02',
    empresaId: 'EMP-004',
    nome: 'Eduardo Nunes',
    email: 'eduardo.nunes@sistemasintegrados.com.br',
    cpf: '963.852.741-07',
    senha: 'sistemas2024',
    role: 'operador',
    ativo: true,
  },
  {
    id: 'op-004-03',
    empresaId: 'EMP-004',
    nome: 'Gabriela Lima',
    email: 'gabriela.lima@sistemasintegrados.com.br',
    cpf: '852.741.963-08',
    senha: 'sistemas2024',
    role: 'visualizador',
    ativo: true,
  },
];

export function getOperadoresByEmpresaId(empresaId: string): OperadorAdmin[] {
  return operadoresAdmin.filter(o => o.empresaId === empresaId);
}

export function getOperadorByEmail(email: string): OperadorAdmin | undefined {
  return operadoresAdmin.find(o => o.email === email);
}